/* tslint:disable */
/* eslint-disable */

/*
      selectedOptions {
        rewards {
          type
        }
        perks {
          type
        }
      }
*/

export const getCardRegisterClientSecretAndCustomerId = /* GraphQL */ `
  query GetPartnerCardRegisterClientSecretAndCustomerId {
    getPartnerCardRegisterClientSecretAndCustomerId {
      customerId
      clientSecret
    }
  }
`;

export const getPartner = /* GraphQL */ `
  query GetPartner {
    getPartner {
      id
      emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      status
      images {
        logoUrl
      }
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
          employmentStartDate
          birthday
        }
        percentage
        availableSeats
      }
      offerAmountsManagement {
        offerBoost {
          isBoostingAllOffers
          boostAmount
          boostLimitPerUser
        }
      }
      lsaGroups {
        groupId
        groupName
      }
    }
  }
`;

export const getPartnerBillingPortalLink = /* GraphQL */ `
  query GetPartnerBillingPortalLink {
    getPartnerBillingPortalLink
  }
`;

export const getGroupLifestyleAnalytics = /* GraphQL */ `
  query GetPartnerGroupLifestyleAnalytics($groupId: String!) {
    getPartnerGroupLifestyleAnalytics(groupId: $groupId) {
      sevenDays {
        totalSaved {
          coveredAmount
          costAmount
        }
        averageSavedPerMember {
          coveredAmount
          costAmount
        }
        participationRate
        categoryBreakdown {
          categoryId
          amount
        }
        topCategories {
          categoryId
          amount
        }
        topUsers {
          userId
          totalSaved
        }
        dailySavings {
          date
          amount
        }
        weeklySavings {
          weekStart
          amount
        }
        monthlySavings {
          month
          amount
        }
        pendingTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        completedTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        totalBudgetRemaining
        totalSpent
      }
      thirtyDays {
        totalSaved {
          coveredAmount
          costAmount
        }
        averageSavedPerMember {
          coveredAmount
          costAmount
        }
        participationRate
        categoryBreakdown {
          categoryId
          amount
        }
        topCategories {
          categoryId
          amount
        }
        topUsers {
          userId
          totalSaved
        }
        dailySavings {
          date
          amount
        }
        weeklySavings {
          weekStart
          amount
        }
        monthlySavings {
          month
          amount
        }
        pendingTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        completedTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        totalBudgetRemaining
        totalSpent
      }
      yearToDate {
        totalSaved {
          coveredAmount
          costAmount
        }
        averageSavedPerMember {
          coveredAmount
          costAmount
        }
        participationRate
        categoryBreakdown {
          categoryId
          amount
        }
        topCategories {
          categoryId
          amount
        }
        topUsers {
          userId
          totalSaved
        }
        dailySavings {
          date
          amount
        }
        weeklySavings {
          weekStart
          amount
        }
        monthlySavings {
          month
          amount
        }
        pendingTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        completedTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        totalBudgetRemaining
        totalSpent
      }
      oneYear {
        totalSaved {
          coveredAmount
          costAmount
        }
        averageSavedPerMember {
          coveredAmount
          costAmount
        }
        participationRate
        categoryBreakdown {
          categoryId
          amount
        }
        topCategories {
          categoryId
          amount
        }
        topUsers {
          userId
          totalSaved
        }
        dailySavings {
          date
          amount
        }
        weeklySavings {
          weekStart
          amount
        }
        monthlySavings {
          month
          amount
        }
        pendingTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        completedTransactions {
          transactionId
          userId
          brandName
          firstName
          lastName
          amount
          date
          categoryId
          status
        }
        totalBudgetRemaining
        totalSpent
      }
      statusBreakdown {
        completed {
          totalSaved {
            coveredAmount
            costAmount
          }
          averageSavedPerMember {
            coveredAmount
            costAmount
          }
          participationRate
          categoryBreakdown {
            categoryId
            amount
          }
          topCategories {
            categoryId
            amount
          }
          topUsers {
            userId
            totalSaved
          }
          dailySavings {
            date
            amount
          }
          weeklySavings {
            weekStart
            amount
          }
          monthlySavings {
            month
            amount
          }
          pendingTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          completedTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          totalBudgetRemaining
          totalSpent
        }
        pending {
          totalSaved {
            coveredAmount
            costAmount
          }
          averageSavedPerMember {
            coveredAmount
            costAmount
          }
          participationRate
          categoryBreakdown {
            categoryId
            amount
          }
          topCategories {
            categoryId
            amount
          }
          topUsers {
            userId
            totalSaved
          }
          dailySavings {
            date
            amount
          }
          weeklySavings {
            weekStart
            amount
          }
          monthlySavings {
            month
            amount
          }
          pendingTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          completedTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          totalBudgetRemaining
          totalSpent
        }
        rejected {
          totalSaved {
            coveredAmount
            costAmount
          }
          averageSavedPerMember {
            coveredAmount
            costAmount
          }
          participationRate
          categoryBreakdown {
            categoryId
            amount
          }
          topCategories {
            categoryId
            amount
          }
          topUsers {
            userId
            totalSaved
          }
          dailySavings {
            date
            amount
          }
          weeklySavings {
            weekStart
            amount
          }
          monthlySavings {
            month
            amount
          }
          pendingTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          completedTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          totalBudgetRemaining
          totalSpent
        }
        all {
          totalSaved {
            coveredAmount
            costAmount
          }
          averageSavedPerMember {
            coveredAmount
            costAmount
          }
          participationRate
          categoryBreakdown {
            categoryId
            amount
          }
          topCategories {
            categoryId
            amount
          }
          topUsers {
            userId
            totalSaved
          }
          dailySavings {
            date
            amount
          }
          weeklySavings {
            weekStart
            amount
          }
          monthlySavings {
            month
            amount
          }
          pendingTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          completedTransactions {
            transactionId
            userId
            brandName
            firstName
            lastName
            amount
            date
            categoryId
            status
          }
          totalBudgetRemaining
          totalSpent
        }
      }
    }
  }
`;

export const getLifestyleTransactions = /* GraphQL */ `
  query GetLifestyleTransactions($status: String, $offset: Int!, $limit: Int!, $startDate: String, $endDate: String, $searchTerm: String) {
    getLifestyleTransactions(status: $status, offset: $offset, limit: $limit, startDate: $startDate, endDate: $endDate, searchTerm: $searchTerm) {
      docs
      totalDocs
    }
  }
`;

export const getPartnerCheckoutPortalLink = /* GraphQL */ `
  query GetPartnerCheckoutPortalLink {
    getPartnerCheckoutPortalLink
  }
`;

export const getPartnerUpdatedSeatCount = /* GraphQL */ `
  query GetPartnerUpdatedSeatCount {
    getPartnerUpdatedSeatCount
  }
`;

export const getPartnerPaymentMethods = /* GraphQL */ `
  query GetPartnerPaymentMethods {
    getPartnerPaymentMethods {
      cardBrand
      expiryMonth
      expiryYear
      lastFourDigits
      paymentId
    }
  }
`;

export const getPartnerInvoices = /* GraphQL */ `
  query GetPartnerInvoices {
    getPartnerInvoices {
      id
      createdDate
      amountPaid
      amountDue
      downloadUrl
      planType
      periodEnd
      periodStart
      nextPaymentAttempt
      chargeDate
    }
  }
`;

export const getPartnerBillingDetails = /* GraphQL */ `
  query GetPartnerBillingDetails {
    getPartnerBillingDetails {
      planAmount
    }
  }
`;

export const getPresignedUrlS3 = /* GraphQL */ `
  query GetPresignedUrlS3($filename: String!, $filepath: String!, $bucket: String!) {
    getPresignedUrlS3(filename: $filename, filepath: $filepath, bucket: $bucket)
  }
`;

export const getAllGiftCardOffers = /* GraphQL */ `
  query GetAllGiftCardOffers {
    getAllGiftCardOffers {
      brandName
      id
      networkName
      offerId
      presetAmounts
      activationSettings {
        isVariableValue
        maxActivationAmount
        minActivationAmount
        forcedMaxActivationAmount
        forcedMinActivationAmount
      }
      images {
        imageUrl
        imageType
        imageSize
      }
    }
  }
`;

export const getPartnerStatistics = /* GraphQL */ `
  query GetPartnerStatistics {
    getPartnerStatistics {
      current {
        date
        totalRewardFiatValue
        numTeamMembers
        numActiveMembers
        numPerkPartners
        numAirdrops
        popularBrands {
          brandName
          numSales
        }
      }
      previous {
        date
        totalRewardFiatValue
        numTeamMembers
        numActiveMembers
        numPerkPartners
        numAirdrops
        popularBrands {
          brandName
          numSales
        }
      }
    }
  }
`;

export const getPartnerAirdropTransactions = /* GraphQL */ `
  query GetAirdropTransactions {
    getAirdropTransactions {
      userId
      createdAt
      completionDate
      externalRef {
        type
        data {
          totalSaleAmount
          billingInformation {
            partner_receipt_url
          }
          externalData {
            brandName
          }
        }
      }
    }
  }
`;

export const getPartnerDashboardData = /* GraphQL */ `
  query GetPartnerDashboardData {
    getPartnerDashboardData {
      dashboardData {
        monthlySavings {
          _id {
            year
            month
          }
          savings
        }
        topBrands {
          _id
          brandName
          totalPurchases
          brandLogo
          transactionType
        }
        allTimeSavings
        lastThreeAirdrops {
          firstName
          lastName
          amount
          date
          brandName
        }
      }
      onboardingData {
        onboardedUsers
        pendingUsers
        totalUsers
      }
      lsaDashboardData {
        totalReimbursed
        participationRate
        averageReimbursedPerUser
        recentPendingTransactions {
          transactionId
          userId
          firstName
          lastName
          date
          amount
          categoryId
        }
      }
    }
  }
`;

export const getLSACategories = /* GraphQL */ `
  query GetLSACategories {
    getLSACategories {
      id
      name
      description
      icon
      examples
    }
  }
  `;
  
export const getLifestyleGroup = /* GraphQL */ `
  query GetLifestyleGroup($groupId: String!) {
    getLifestyleGroup(groupId: $groupId) {
      id
      name
      partnerId
      categories {
        id
        name
        description
        icon
        examples
      }
      yearlySpendingLimit
      currency
      prorated
      startDate
      resetDate
      runOffPeriod
      status
      membersCount
      coveragePercentage
      createdAt
      updatedAt
    }
  }
  `;
